<template lang="pug">
  .modal-de-confirmacao-de-ponto-sem-voz
    div {{ $t('componentes.marcacao.componentes.modalDeConfirmacaoDePontoSemVoz.pontoSemVoz') }}
    label(
      v-if="exibirNaoMostrarNovamente"
      for="nao-mostrar-novamente"
    )
      input(
        type="checkbox"
        name="nao-mostrar-novamente"
        v-model="memorizador"
      )
      span {{ $t('componentes.marcacao.componentes.modalDeConfirmacaoDePontoSemVoz.naoMostrarNovamente') }}
</template>

<script>
import { memorizadorLocal } from 'src/common/mixins'

export default {
  name: 'ModalDeConfirmacaoDePontoSemVoz',

  mixins: [memorizadorLocal()],

  props: {
    exibirNaoMostrarNovamente: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
label[for="nao-mostrar-novamente"] {
    margin-top: 2rem;
    display: block;
    text-align: left;
}

label[for="nao-mostrar-novamente"] span {
    margin-left: 1rem
}
</style>
